import { forwardRef, useImperativeHandle, useRef } from "react";
import styled from "styled-components";

const TabContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex: 1 1 auto;
	width: 100%;
	height: ${(props) => (props.hasIcon ? "64px" : "48px")};
	color: var(
		${(props) =>
			props.isActive ? "--color-primary" : "--color-on-surface"}
	);
	cursor: pointer;
	transition: 0.3s;
	-webkit-user-select: none;
	user-select: none;
`;

const Tab = forwardRef(({ label, icon, onClick, isActive }, ref) => {
	const tabRef = useRef(null);
	const labelRef = useRef(null);

	useImperativeHandle(ref, () => {
		return {
			getLabelWidth: () => {
				if (labelRef.current) {
					return labelRef.current.offsetWidth;
				}
				return -1;
			},
			getLabelStart: () => {
				if (tabRef.current && labelRef.current) {
					return tabRef.current.offsetLeft + labelRef.current.offsetLeft;
				}
				return -1;
			}
		};
	});

	return (
		<TabContainer
			ref={tabRef}
			onClick={onClick}
			isActive={isActive}
			hasIcon={icon}
		>
			{icon && <span className="material-symbol fill">{icon}</span>}
			<span ref={labelRef}>{label}</span>
		</TabContainer>
	);
});

export default Tab;
